export const StarterFeatures = [
  'Scale Your Brand',
  'Automate FBA Shipments ',
  'Sync Product Catalog',
  'Detailed Fulfillment Tracking',
  'Analyze Sales & Order Metrics',
  'Manage Customer Relationships',
  '2 Marketplaces',
  '2 Users',
];

export const FullSendFeatures = [
  'Expand Your Global Enterprise',
  'Supply Chain Management',
  'Custom Wholesale Operations',
  'SKU Performance Analytics',
  'Sync 3PL/WMS to Marketplaces',
  'Sync All Product Catalogs',
  'Automate D2C, B2B & FBA Shipments',
  'Detailed Fulfillment Tracking',
  'Predictive Order Purchasing',
  'Analyze Sales & Order Metrics',
  'Manage Customer Relationships',
  '5 Marketplaces',
  '5 Users',
];

export const ThreePLSendFeatures = [
  'Operate Multiple Brands',
  'Sync 3PL/WMS to Marketplaces',
  'Automate D2C & B2B Shipments',
  'Predictive Order Purchasing',
  'Detailed Fulfillment Tracking',
  'Analyze Sales & Order Metrics',
  'Manage Customer Relationships',
  '3 Marketplaces',
  '3 Users',
];

export const PlanConstant = {
  starter: 'Starter',
  fullSend: 'Full Send',
  '3PL': '3PL',
};

export const planPermissions = {
  starter: 'starter',
  fullSend: 'fullsend',
  '3PL': '3pl',
};

export const planPermissionsToPlanConstant = {
  starter: 'Starter',
  fullsend: 'Full Send',
  '3pl': '3PL',
};

export const PlanTextMap = {
  Starter: 'List & Sell',
  'Full Send': 'Full Suite',
  '3PL': 'Ship & Store',
};

export const getPlanDisplayName = subscription => {
  if (subscription.display_name) {
    return PlanTextMap[subscription.display_name] || subscription.display_name;
  }
  return PlanTextMap[subscription.name] || subscription.name;
};
